// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import useUuid from '../../../../../hooks/useUuid';
import BoomUIBySkinId from '../../../constants/ui';
import { type BoomSkinId } from '../../../types/global';

const Wrapper = styled.div``;

const SvgElement = styled.svg`
  width: 100%;
  height: 100%;

  ${({ $isInProgress, $skinId }) => {
    const svgStyle = BoomUIBySkinId[$skinId].SEPARATOR_STYLE[$isInProgress ? 'inProgress' : 'default'];

    if ($isInProgress) {
      return css`
        --boom-step-fill-color: ${svgStyle.fillColor};
        --boom-step-fill-opacity: ${svgStyle.fillOpacity};
        --boom-step-stroke-opacity: ${svgStyle.strokeOpacity};
        --boom-step-stroke-gradient-primary-color: ${svgStyle.strokeGradientPrimaryColor};
        --boom-step-stroke-gradient-secondary-color: ${svgStyle.strokeGradientSecondaryColor};
      `;
    }
    return css`
      --boom-step-fill-color: ${svgStyle.fillColor};
      --boom-step-fill-opacity: ${svgStyle.fillOpacity};
      --boom-step-stroke-opacity: ${svgStyle.strokeOpacity};
      --boom-step-stroke-gradient-primary-color: ${svgStyle.strokeGradientPrimaryColor};
      --boom-step-stroke-gradient-secondary-color: ${svgStyle.strokeGradientSecondaryColor};
    `;
  }}
`;

const InnerPath = styled.path`
  fill: var(--boom-step-fill-color);
  fill-opacity: var(--boom-step-fill-opacity);
`;

const OuterPath = styled.path`
  stroke-opacity: var(--boom-step-stroke-opacity);
`;

const PrimaryStopGradient = styled.stop`
  stop-color: var(--boom-step-stroke-gradient-primary-color);
`;

const SecondaryStopGradient = styled.stop`
  stop-color: var(--boom-step-stroke-gradient-secondary-color);
`;

type PropsType = {
  className?: string;
  stepDiff: number;
  skinId: BoomSkinId;
};

const BoomStepSeparatorSvgAsComponent = ({ className = '', stepDiff, skinId }: PropsType) => {
  const isCompleted = useMemo(() => stepDiff < 0, [stepDiff]);
  const isInProgress = useMemo(() => stepDiff === 0, [stepDiff]);

  const uuid = useUuid();

  return (
    <Wrapper className={className}>
      <SvgElement
        $skinId={skinId}
        $isInProgress={isInProgress}
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isCompleted ? (
          <>
            <linearGradient
              id={`completed-separator-fill-gradient-${uuid}`}
              gradientUnits="userSpaceOnUse"
              x1="5"
              x2="5"
              y1="0"
              y2="2.992"
            >
              <stop offset="0" stopColor="#0a2919" />
              <stop offset="1" stopColor="#5cd699" />
            </linearGradient>
            <linearGradient
              id={`completed-separator-stroke-gradient-${uuid}`}
              gradientUnits="userSpaceOnUse"
              x1="5"
              x2="5"
              y1="0"
              y2="4.4"
            >
              <stop offset="0" stopColor="#fff" />
              <stop offset="1" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              d="m8.74647 2.24707-3.80157-1.698383-3.71528 1.698423 3.71517 1.60899z"
              fill={`url(#completed-separator-fill-gradient-${uuid})`}
              stroke={`url(#completed-separator-stroke-gradient-${uuid})`}
            />
          </>
        ) : (
          <>
            <InnerPath d="M4.94253 0L3.72529e-08 2.25946L4.94253 4.4L10 2.25946L4.94253 0Z" />
            <OuterPath
              d="M8.74647 2.24707L4.9449 0.548687L1.22962 2.24711L4.94479 3.8561L8.74647 2.24707Z"
              stroke={`url(#default-separator-gradient-${uuid})`}
            />
            <defs>
              <linearGradient
                id={`default-separator-gradient-${uuid}`}
                x1="4.75"
                y1="3.5"
                x2="4.75"
                y2="0.5"
                gradientUnits="userSpaceOnUse"
              >
                <PrimaryStopGradient stopOpacity="0" />
                <SecondaryStopGradient offset="1" />
              </linearGradient>
            </defs>
          </>
        )}
      </SvgElement>
    </Wrapper>
  );
};

export default BoomStepSeparatorSvgAsComponent;
